import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Use CLIENT_ERRORS to bypass the global interceptor on 4xx status codes and handle the error locally
 * Use CLIENT_AND_SERVER_ERRORS to bypass all 4xx and 5xx status codes and handle the error locally
 */
export enum BypassMode {
  NONE = 'NONE',
  CLIENT_ERRORS = 'CLIENT_ERRORS',
  CLIENT_AND_SERVER_ERRORS = 'CLIENT_AND_SERVER_ERRORS',
}

export const BYPASS_ERROR_HANDLING = new HttpContextToken<BypassMode>(() => BypassMode.NONE);

/**
 * Sets BypassMode.CLIENT_ERRORS in an HTTPContext and returns it
 */
export function bypassClientErrorHandling(): HttpContext {
  return new HttpContext().set(BYPASS_ERROR_HANDLING, BypassMode.CLIENT_ERRORS);
}

/**
 * Sets BypassMode.CLIENT_AND_SERVER_ERRORS in an HTTPContext and returns it
 */
export function bypassAllErrorHandling(): HttpContext {
  return new HttpContext().set(BYPASS_ERROR_HANDLING, BypassMode.CLIENT_AND_SERVER_ERRORS);
}
